import { observer } from 'mobx-react';
import { BasicInfo } from './basic-info/basic-info';
import styles from './bidder-campaign-form.module.scss';
import { BidderDomainList } from './bidder-domain-limit/bidder-domain-list';
import { BidderTargeting } from './targeting/bidder-targeting';
import { BidderInitialBids } from './bidder-initial-bids/bidder-initial-bids';
import { useBidderInputOptions } from '../../../hooks/apis/use-bidder-input-options';
import { BidderWhitelistBlacklistContainer } from './whitelist-blacklist/bidder-whitelist-blacklist-container';

export const BidderCampaignForm = observer(() => {
	useBidderInputOptions();

	return (
		<div className={styles.wrapper}>
			<BasicInfo />
			<BidderInitialBids />
			<BidderTargeting />
			<BidderWhitelistBlacklistContainer />
			<BidderDomainList />
		</div>
	);
});
